import { HelpContent } from '../../../../UI-Lib/Help-Tooltip';

export const RETRIEVE_ASSETS_HELP: HelpContent[] = [
    {
        helpContentId: 'retrieve-assets.title',
        tooltipText: 'List of assets that are available to add to this allocation. Assets must be in the same top-level company, and have a lien date corresponding to this allocation\'s assessment revision tax year.',
        hasIcon: true
    }
];
